export type NotificationType = 'info' | 'success' | 'warning' | 'error' | 'system'
export type NotificationPriority = 1 | 2 | 3 | 4

export const NotificationType = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  SYSTEM: 'system',
} as const

export const NotificationPriority = {
  LOW: 1,
  NORMAL: 2,
  HIGH: 3,
  CRITICAL: 4,
} as const

export interface Notification {
  id: string
  type: NotificationType
  title: string
  message: string
  read: boolean
  createdAt: Date
  priority?: NotificationPriority
  expiresAt?: Date
  actionUrl?: string
  actionText?: string
  data?: Record<string, unknown>
}

export interface NotificationSettings {
  enabled: boolean
  types: {
    orders: boolean
    inventory: boolean
    system: boolean
    marketing: boolean
  }
  channels: {
    browser: boolean
    email: boolean
    sms: boolean
  }
}

export interface WebSocketMessage {
  type: string
  data: unknown
  timestamp: Date | number
}

export interface MercureUpdate {
  id: string
  type: string
  data: unknown
  topics: string[]
}

export type ConnectionStatus =
  | 'disconnected'
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'error'

export interface ConnectionMetrics {
  messagesReceived: number
  messagesSent: number
  reconnectCount: number
  latency: number
  averageLatency?: number
  connectedAt?: Date
  lastMessageAt?: Date
  lastHeartbeat?: Date
}

export interface MercureConfig {
  hubUrl: string
  jwtToken?: string
  topics: string[]
  reconnectAttempts?: number
  reconnectDelay?: number
  heartbeatInterval?: number
  heartbeatTimeout?: number
}

export interface MercureEvent<TData = unknown> {
  type: string
  data: TData
  timestamp: Date
  topic?: string
}

export type EventCallback = (event: MercureEvent) => void
export type UnsubscribeFunction = () => void
